export default "__VITE_ASSET__BdA5J5kk__"